// src/pages/Tarifs/TarifsPage.jsx

import React from "react";
import Footer from "./../Home/Footer";
import useScrollToTop from "../../hooks/useScrollToTop";
import AuthIcons from "../../hooks/AuthIcons";
import { useUser } from "../../contexts/UserContext";
import FormContact from "./../Home/FormContact";
import { FaPhoneAlt } from "react-icons/fa";
import Parrainage from "./Parrainage";
import PricingHubSimple from "./components/PricingHubSimple";

const TarifsPage = () => {
  useScrollToTop();

  const { user } = useUser();

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-950 dark:bg-slate-950 dark:text-white">
      {!user && <AuthIcons />}

      <div className="flex-grow">
        <div className="h-[76px] w-full bg-slate-950" />

        <section
          id="tarifs"
          className="relative overflow-hidden bg-slate-50 dark:bg-slate-950"
        >
          <div className="pointer-events-none absolute left-0 top-20 h-72 w-72 rounded-full bg-orange-200/30 blur-3xl dark:bg-orange-500/10" />
          <div className="pointer-events-none absolute right-0 top-48 h-72 w-72 rounded-full bg-sky-200/30 blur-3xl dark:bg-sky-500/10" />

          <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
            <PricingHubSimple />
          </div>
        </section>

        <section className="bg-white py-8 dark:bg-slate-950">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <Parrainage />
          </div>
        </section>

        <section
          id="contact"
          className="relative overflow-hidden bg-slate-950 py-16 text-white"
        >
          <div className="pointer-events-none absolute left-10 top-10 h-40 w-40 rounded-full bg-orange-500/20 blur-3xl" />
          <div className="pointer-events-none absolute bottom-10 right-10 h-40 w-40 rounded-full bg-sky-500/20 blur-3xl" />

          <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-6xl overflow-hidden rounded-[2rem] border border-white/10 bg-white/5 p-6 shadow-[0_25px_80px_rgba(0,0,0,0.35)] backdrop-blur sm:p-8 lg:p-10">
              <div className="grid gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
                <div>
                  <div className="inline-flex rounded-full bg-white/10 px-4 py-2 text-sm font-bold text-white/90">
                    Contact direct
                  </div>

                  <h2 className="mt-5 font-display text-3xl font-bold tracking-tight sm:text-4xl">
                    Vous hésitez entre plusieurs applications ?
                  </h2>

                  <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-300 sm:text-base">
                    Je peux vous aider à choisir la bonne formule selon votre
                    structure, votre budget et vos besoins réels. L’objectif
                    est de proposer une solution claire, utile et adaptée.
                  </p>
                </div>

                <div className="rounded-[2rem] border border-white/10 bg-white/10 p-6">
                  <div className="text-sm font-bold uppercase tracking-[0.16em] text-white/60">
                    Appel rapide
                  </div>

                  <div className="mt-3 text-3xl font-bold tracking-wide sm:text-4xl">
                    06.80.72.77.07
                  </div>

                  <a
                    href="tel:0680727707"
                    className="mt-6 inline-flex min-h-12 w-full items-center justify-center rounded-2xl bg-white px-6 py-3 text-sm font-bold text-slate-950 shadow-lg transition hover:bg-slate-100"
                  >
                    <FaPhoneAlt className="mr-2" />
                    Appeler maintenant
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white py-12 dark:bg-slate-950">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <FormContact />
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default TarifsPage;